import { h, Component, State, Prop } from '@stencil/core';

@Component({
  shadow: true,
  styleUrls: {
    default: 'igws-accordion.default.less',
    rtl: 'igws-accordion.rtl.less',
    rebrand: 'igws-accordion.default.less',
    rtl_rebrand: 'igws-accordion.rtl.less',
    prime: 'igws-accordion.default.less',
    rtl_prime: 'igws-accordion.rtl.less',
    investments: './investments/igws-accordion.default.less',
    rtl_investments: './investments/igws-accordion.rtl.less',
    helpandsupport: './helpandsupport/igws-accordion.default.less',
    rtl_helpandsupport: './helpandsupport/igws-accordion.rtl.less',
    academy: 'igws-accordion.default.less',
    rtl_academy: 'igws-accordion.rtl.less',
    landingpages: 'igws-accordion.default.less',
    rtl_landingpages: 'igws-accordion.rtl.less',
    generic: 'igws-accordion.default.less',
    rtl_generic: 'igws-accordion.rtl.less',
  },
  tag: 'igws-accordion',
})
export class AccordionComponent {
  /**
   * Toggle open/close state
   */
  @State() toggle!: boolean;
  /**
   * Accordion's content
   */
  @Prop() text!: string
   /**
    * Accordion's theme - light/dark
    */
  @Prop() theme!: string;
  /**
   * Accordion style
   */
  @Prop() accordionStyle!: string;
  /**
   * Desktop initial open/close state
   */
  @Prop() desktopInitialState!: string;
  /**
   * Tablet initial open/close state
   */
  @Prop() tabletInitialState!: string;
  /**
   * Mobile initial open/close state
   */
  @Prop() mobileInitialState!: string;

  toggleComponent() {
    this.toggle = !this.toggle;
  }

  decodeText(text: string) {
    return decodeURIComponent(text);
  }

  componentWillLoad() {
    const isMobile: boolean = window.matchMedia('only screen and (max-width: 599px)').matches;
    const isTablet: boolean = window.matchMedia('only screen and (max-width: 800px)').matches;

    if (isMobile) {
      this.toggle = this.mobileInitialState === 'open';
    } else if (isTablet) {
      this.toggle = this.tabletInitialState === 'open';
    } else {
      this.toggle = this.desktopInitialState === 'open';
    }
  }

  render() {
    const expanded: string = this.toggle ? 'accordion--expanded' : '';
    const theme: string = this.theme ? `accordion--${this.theme}` : '';

    return (
      <div class={`accordion ${expanded} ${theme}`}>
        {this.text ? [
          <button type="button" class={`accordion__label accordion--${this.accordionStyle}`} onClick={() => this.toggleComponent()}>
            <span class="accordion__text" innerHTML={this.decodeText(this.text)}></span>
          </button>,
          <div class="accordion__content">
            <slot name="content" />
          </div>
        ] : null}
      </div>
    );
  }
}
